import type {OhdHba1cBreakdown} from '../types';

export interface Hba1cRow {
    risk: string;
    current: number;
    currentPct: string;
    prior: number | null;
    priorPct: string | null;
    change: string | null;
}

function pct(numerator: number, denominator: number): string {
    if (!denominator) return '0%';
    return `${((numerator / denominator) * 100).toFixed(1)}%`;
}

function pctValue(numerator: number, denominator: number): number {
    if (!denominator) return 0;
    return (numerator / denominator) * 100;
}

function changeBetween(currentNum: number, currentDen: number, priorNum: number, priorDen: number): string {
    const delta = pctValue(currentNum, currentDen) - pctValue(priorNum, priorDen);
    const sign = delta >= 0 ? '+' : '';
    return `${sign}${delta.toFixed(1)}%`;
}

export function buildHba1cRows(
    current: OhdHba1cBreakdown,
    prior: OhdHba1cBreakdown | null
): Hba1cRow[] {
    const categories: Array<{risk: string; key: keyof OhdHba1cBreakdown}> = [
        {risk: 'Normal: less than 5.7', key: 'normal'},
        {risk: 'Pre Diabetic: 5.7 - 6.4', key: 'pre_diabetic'},
        {risk: 'Diabetic: 6.5+', key: 'diabetic'},
    ];

    return categories.map(({risk, key}) => {
        const currentNum = current[key];
        const priorNum = prior ? prior[key] : null;
        return {
            risk,
            current: currentNum,
            currentPct: pct(currentNum, current.total),
            prior: priorNum,
            priorPct: prior ? pct(priorNum as number, prior.total) : null,
            change: prior ? changeBetween(currentNum, current.total, priorNum as number, prior.total) : null,
        };
    });
}
